module.exports = __webpack_public_path__ + "img/failed 241@3x.bc15bd40.png";